import { Play, BadgeCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

export const RealResults = () => (
  <section data-testid="real-results-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="07"
        eyebrow="Inside Krystal"
        title="Real Clinic. Real Treatment. Real Reduction."
        copy="A look inside our Ameerpet clinic — and an actual underarm laser hair reduction result from Krystal Skin Clinic."
      />
      <div className="mt-14 grid lg:grid-cols-2 gap-6 items-stretch">
        <Reveal>
          <div className="relative h-full rounded-[2rem] border border-champagne/60 overflow-hidden bg-teal-900 shadow-[0_40px_80px_-40px_rgba(144,41,141,0.4)]">
            <video
              data-testid="clinic-video"
              src="/media/offer-reel.mp4"
              poster="/media/clinic-room.jpeg"
              controls
              playsInline
              preload="metadata"
              className="h-full w-full object-cover aspect-[4/5] lg:aspect-auto"
            />
            <span className="pointer-events-none absolute top-5 left-5 inline-flex items-center gap-2 rounded-full bg-ivory/90 backdrop-blur px-4 py-2 font-mono text-[0.6rem] uppercase tracking-[0.25em] text-teal">
              <Play className="w-3 h-3" strokeWidth={2} />
              Clinic Reel
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="relative h-full rounded-[2rem] border border-champagne/60 overflow-hidden bg-white shadow-[0_40px_80px_-40px_rgba(144,41,141,0.3)]">
            <img
              src="/media/before-after.png"
              alt="Before and after underarm laser hair reduction at Krystal Skin Clinic"
              className="h-full w-full object-cover aspect-[4/5] lg:aspect-auto"
              loading="lazy"
              data-testid="before-after-image"
            />
            <span className="absolute top-5 left-5 inline-flex items-center gap-2 rounded-full bg-teal px-4 py-2 font-mono text-[0.6rem] uppercase tracking-[0.25em] text-champagne-light">
              <BadgeCheck className="w-3 h-3" strokeWidth={2} />
              Actual Client Result
            </span>
            <p className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-teal-900/80 to-transparent px-6 pt-14 pb-5 text-[0.65rem] font-light leading-relaxed text-ivory/80">
              Individual results vary depending on hair type, skin type, hormones and individual response.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
